import {useUser} from '@github-ui/use-user'
import {useMemo} from 'react'

import type {SavedView} from '../../types'
import {splitViewsByVisibility} from '../../utils/views-visibility'
import type {PinControls} from './PinViewMenuItem'
import styles from './RepositoryViews.module.css'
import {ViewsSection} from './ViewsSection'

type ViewsSectionsProps = {
  views: SavedView[]
  owner: string
  repo: string
  newViewUrl: string
  viewerCanManageViews?: boolean
  showPinControls?: boolean
  pinControls?: PinControls
}

export function ViewsSections({
  views,
  owner,
  repo,
  newViewUrl,
  viewerCanManageViews = false,
  showPinControls = false,
  pinControls,
}: ViewsSectionsProps) {
  const {team, personal} = useMemo(() => splitViewsByVisibility(views), [views])
  const {currentUser} = useUser()
  const hasPersonalSection = currentUser != null

  const shared = {owner, repo, newViewUrl, viewerCanManageViews, showPinControls, pinControls}

  return (
    <div className={styles.viewsSections}>
      {hasPersonalSection && (
        <ViewsSection
          visibility="personal"
          views={personal}
          otherSectionsHaveViews={team.length > 0}
          hasSiblingSection
          {...shared}
        />
      )}
      <ViewsSection
        visibility="team"
        views={team}
        otherSectionsHaveViews={hasPersonalSection && personal.length > 0}
        hasSiblingSection={hasPersonalSection}
        {...shared}
      />
    </div>
  )
}
